import styled from '@emotion/styled'

const Layout = styled.section``

Layout.Header = styled.header`
  display: flex;
  background-color: #0e0e0e;
  height: 80px;
  width: 100%;
`

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 0 auto;
`

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`

Layout.LogoText = styled.span`
  font-size: 16px;
  color: #c3a572;
  font-weight: 700;
`

Layout.Navigation = styled.nav`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
  svg {
    fill: #ffffff;
  }
`

Layout.Link = styled.span`
  margin-left: 10px;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 15px;
  color: #0c0c0c;
  svg {
    fill: #ffffff;
  }
`

Layout.Hero = styled.div`
  background: url(${({ backgroundImage }) => backgroundImage});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  position: relative;
  &:after {
    content: '';
    background: #00000040;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

Layout.HeroContainer = styled.div`
  display: flex;
  min-height: calc(100vh + 70px);
  width: 100%;
  flex-wrap: wrap;
  z-index: 1;
  position: relative;
  align-items: flex-end;
`

Layout.TitleContainer = styled.div`
  display: flex;
  max-width: 470px;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: 6em;
  color: #ffffff;
`

Layout.Title = styled.h1`
  font-size: 44px;
  color: #ffffff;
  font-weight: 700;
  line-height: 1.2; 
  margin-bottom: 0.2em;
`
Layout.Subtitle = styled.p`
  font-size: 18px;
  color: #ffffff;
  line-height: 2; 
`
Layout.CTA = styled.button`
  width: fit-content;
  background-color: #c3a572;
  color: #1c1c1c;
  font-size: 16px;
  font-weight: 700;
  padding: 12px 30px;
  margin-top: 2em;
  border-radius: 5px;
`
Layout.HeroImageContainer = styled.div`
  overflow: hidden;
  width: 50%;
`
export default Layout
